import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { type Dayjs } from 'dayjs';

export type DailyReportDateFilter = {
	reportStartDate: Dayjs | string | null;
	reportEndDate: Dayjs | string | null;
};

type Props = {
	value: DailyReportDateFilter;
	onChange: (date: DailyReportDateFilter) => void;
};

export const DailyReportDateFilter = ({ value, onChange }: Props) => {
	const updateValue = (changes: Partial<DailyReportDateFilter>) => {
		onChange({
			...value,
			...changes,
		});
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Stack spacing={2}>
				<Typography variant='subtitle1' fontWeight={600}>
					Select a date range for the daily report
				</Typography>

				<Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
					<DatePicker<Dayjs>
						label='Start date'
						value={value.reportStartDate ? dayjs(value.reportStartDate) : null}
						maxDate={value.reportEndDate as Dayjs}
						onChange={(date) => updateValue({ reportStartDate: date })}
						slotProps={{ textField: { fullWidth: true } }}
					/>

					<DatePicker<Dayjs>
						label='End date'
						value={value.reportEndDate ? dayjs(value.reportEndDate) : null}
						minDate={value.reportStartDate as Dayjs}
						onChange={(date) => updateValue({ reportEndDate: date })}
						slotProps={{ textField: { fullWidth: true } }}
					/>
				</Stack>
			</Stack>
		</LocalizationProvider>
	);
};
